import React, { Component } from 'react';
import { Grid, Cell } from 'react-flexr';
import SellingPoint from './selling-point';

export default class UniqueSellingPoints extends Component {
  render() {
    return (
      <Grid>
        <Cell palm="1/1">
          <SellingPoint
            header="Gratis"
            text="Det er helt gratis og uforpligtende at benytte vores site til at sammenligne og finde tilbud"
          />
        </Cell>

        <Cell palm="1/1">
          <SellingPoint
            header="Spar penge, få overblik"
            text="Find de tilbud der passer bedst til dine behov, og få et overblik så du kender dine muligheder"
          />
        </Cell>

        <Cell palm="1/1">
          <SellingPoint
            header="Nemt og hurtigt"
            text="Det er nemt at sammenligne tilbud, og du kan hurtigt bestille dem som interesser dig online"
          />
        </Cell>
      </Grid>
    );
  }
}
